import { Col, Container, Row } from "reactstrap";
import SalesByTimePeriod from "./SalesByTimePeriod/SalesByTimePeriod";
import SalesByProductCategory from "./SalesByProductCategory/SalesByProductCategory";
import SalesByProduct from "./SalesByProduct/SalesByProduct";

const OrderAnalytics = () => {
  const data = [
    { label: "Total Sales", value: "$50,000" },
    { label: "Average order value", value: "$75" },
    { label: "Orders Placed", value: "667" },
    { label: "Conversion Rate", value: "3.5%" },
  ];

  return (
    <div
      style={{
        background: "#f2f2f2",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <h4 className="fw-semibold mb-3">Order Analytics</h4>
      <Container fluid>
        <h5 className="fw-semibold">Overview</h5>
      </Container>

      <div className="bg-white p-4 mx-3 rounded-3">
        <Row className="g-0 justify-content-between row-gap-4">
          <Col lg={3} xxl={2} className="d-grid gap-2">
            {data.map(({ value, label }) => (
              <div
                style={{
                  borderRadius: ".7rem",
                  border: "1px solid #d9d9d9",
                  paddingBlock: ".5rem",
                  textAlign: "center",
                }}
              >
                <div style={{ fontWeight: 600, color: "#EC7426" }}>
                  {value}
                </div>
                <div className="fw-medium">{label}</div>
              </div>
            ))}
          </Col>
          <Col lg={7} xxl={8} className="d-flex">
            <div
              style={{
                backgroundColor: "#F2F2F2",
                flex: 1,
                display: "grid",
                placeItems: "center",
                minHeight: "250px",
              }}
            >
              <span style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                Graph of Order Volume Trend
              </span>
            </div>
          </Col>
        </Row>
      </div>

      <SalesByTimePeriod />
      <SalesByProductCategory />
      <SalesByProduct />
    </div>
  );
};

export default OrderAnalytics;